import React, { useContext, useEffect } from 'react'
import { GeneralContext } from '../../context/'
import { Container } from 'reactstrap'
import { withRouter } from 'react-router-dom'

const Index = () => {
    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Reportes`,
            parentLink: '/reports',
            item: `Reportes`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Index)
